import { call, takeLatest } from "redux-saga/effects";
import * as translationJobApi from "../apis/translationJobApi"
import { TRANALATIONJOB_LIST } from "../actions/types";

export function* translationJobListWorker(action) {
    try {
        const res = yield call(translationJobApi.translationJobListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}




export function* translationJobListWatcher() {
    yield takeLatest(TRANALATIONJOB_LIST, translationJobListWorker);
}

